import { create } from 'zustand';

/** Only one inline sign-in may own the code step at a time — two live code
    boxes race for the same OTP. Neutral because both the storefront cards and
    the main page's strip use it. */
interface ActiveAuthState {
  activeAuthId: string | null;
  claimAuth: (id: string) => void;
}

export const useActiveAuth = create<ActiveAuthState>((set) => ({
  activeAuthId: null,
  claimAuth: (id) => set({ activeAuthId: id }),
}));
